var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.274 9.05a5.687 5.687 0 1 0-1.223 1.223v.001a1 1 0 0 0 .086.1l3.37 3.37a.875.875 0 1 0 1.237-1.238l-3.37-3.369a1 1 0 0 0-.1-.086m.226-3.363a4.813 4.813 0 1 1-9.625 0 4.813 4.813 0 0 1 9.625 0"
  })));
};
export default SvgSearch;